window.dataDefArr = [];

window.getDataDefinition = function(){
    dataDefArr = [];
    var object= document.getElementById('definition').value;
    object=JSON.parse(object);
    filterObject(object);
    document.getElementById('data_definition').value = JSON.stringify(dataDefArr);
    return true;
}

window.filterObject = function(object) {
    var result = null;
    if(object instanceof Array) {
        for(var i = 0; i < object.length; i++) {
            result = filterObject(object[i]);
        }
    }
    else
    {
        for(var prop in object) {
            if(prop == 'input') {
                if(object[prop] == true) {
                    let flagResult=filterInput(object);
                    if( flagResult ){
                        let fieldDef={ "key" : object["key"], "label" : object["label"], "type" : object["type"], "tbl_header" : true, "unique" :  object["unique"]? object["unique"] : false, "input" :  object["input"]? object["input"] : false }
                        if( object['type'] == 'select' ){
                            fieldDef.dataSrc = ( object["dataSrc"] ) ? object["dataSrc"] : "values";
                            fieldDef.dataType = ( object["dataType"] ) ? object["dataType"] : "object";
                        }
                        if(object['properties']) {
                            fieldDef.fieldVerifyFlag = object['properties']['fieldVerifyFlag']? object['properties']['fieldVerifyFlag'] : 'No';
                            fieldDef.verifyFieldName = object['properties']['verifyFieldName']? object['properties']['verifyFieldName'] : '';
                        }
                        if( object['dbIndex'] ){ //id proof like aadhar,license
                            fieldDef.dbIndex = object['dbIndex'];
                            fieldDef.defaultValue = object['defaultValue'];
                        }
                        if( object['type'] == 'file' ){
                            fieldDef.image = ( object['image'] ) ? true : false;
                        }
                        dataDefArr.push(fieldDef);
                    }
                }
            }
            if(object[prop] instanceof Object || object[prop] instanceof Array)
                result = filterObject(object[prop]);
        }
    }
    return result;
}

var excludeTypeArr = [ "button", "submit", "datagrid", "editgrid", "tree", "container", "datamap", "recaptcha" ];
var excludeKeyArr  = [ "enterOtp" ]
var excludeKeyLength = excludeKeyArr.length;
window.filterInput = function(obj){
    let flag = true;
    if( excludeTypeArr.includes(obj.type) ){
        flag = false;  
    }
    for(let i=0; i < excludeKeyLength; i++ ){
        if (obj.key.indexOf(excludeKeyArr[i]) !== -1) {
            flag = false;
            break;
        }
    }
    return flag;
}